const $ = require('jquery');
import _ from 'underscore';
import run from '../../utilities/run';
import render from "../../utilities/render";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {instantiateSelect2, bindDocSelect2CloseRefocus, bindSelect2OnTypeForDesktop} from "../../utilities/select2able";
import {instantiateSwitchery} from "../../utilities/instantiateSwitchery";
import {isBlank, isPresent, removeAmpersand, removeNonDigit} from "../../utilities/general";
const modalHtml = require("../../sharedHtml/modal.html");
const mainModalHtml = require("./html/modal.html");
const receiptExistForBanNoHtml = require("./html/receiptExistForBanNo.html");
const updateBoxQuantityModalBody = require("./html/updateBoxQuantityModalBody.html");
const updatePolyBagsQuantityModalBody = require("./html/updatePolyBagsQuantityModalBody.html");
const warningModalBodyFor10BoxBody = require("./html/warningModalBodyFor10Box.html");
const warningModalBodyFor10PolyBagBody = require("./html/warningModalBodyFor10PolyBag.html");
const warningModalBodyFor30BoxBody = require("./html/warningModalBodyFor30Box.html");
const warningModalBodyFor30PolyBagBody = require("./html/warningModalBodyFor30Box.html");
const invalidEntryModalBodyForSerialNumberHtml = require('./html/invalidEntryModalBodyForSerialNumber.html');


const packingSkuListHtml = require("./html/packingSkuList.html");
const packingSkuOptionHtml = require("./html/packingSkuOption.html");

require("./fxoReceivingScreen.less");
const fxoReceivingAddProductTemplate = require("./html/fxoReceivingAddProductTemplate.html");

export default function FxoReceivingScreenLogic(mainEl) {
  const self = this;
  const elsPage = {};
  const elsModals = {};
  var submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();

  let totalItemsOnPage = mainEl.data('total-items') || 0;
  const addBoxWarnLimit = mainEl.data('add-box-warning-total') || 10;
  const addBoxWarnDisplay = mainEl.data('add-box-warning-display') || 'ten'
  const addPolyBagWarnLimit = mainEl.data('add-poly-bag-warning-total') || 5;
  const addPolyBagWarnDisplay = mainEl.data('add-poly-bag-warning-display') || 'five'
  const addBoxMaxLimit = mainEl.data('add-box-max-total') || 30;
  const addPolyBagMaxLimit = mainEl.data('add-poly-bag-max-total') || 30;
  const addBoxMaxDisplay = mainEl.data('add-box-max-display') || 'thirty';
  const addPolyBagMaxDisplay = mainEl.data('add-poly-bag-max-display') || 'thirty';

  self.init = function() {
    bindElements();
    hideInitial();
    chooseInputPlaceholder();
    showATTOptionsDiv();

    //This needs to be delayed to allow select2 to initialize
    setTimeout(()=>{
      setItemsInitialState();
    },10);
  };

  function hideInitial(){
    $("#ban-order-number-div").hide();
    $("#last-house-zip-div").hide();
    $("#last-house-zip-serial-div").hide();

    hideAddBoxValidationPills(mainEl);
  }

  function showATTOptionsDiv(){
    const searchByValue = $("#customer-search-by").val();
    const attOptionsData = mainEl.data('att-options-json-object');
        if(searchByValue == 'ACCOUNT_SEARCH'){
            $("#single-search-value").val("");
            $("#ban-order-number-div").show();
            $("#last-house-zip-div").hide();
            $("#last-house-zip-serial-div").hide();
            const accSearchOptions = attOptionsData.ACCOUNT_SEARCH;
            $(accSearchOptions).each(function(){
              if(this.cdmDescription == 'Y'){
                $("#single-search-value").prop('required', true);
              }else {
                $("#single-search-value").prop('required', false);
              }
                $("#single-search-value").attr("placeholder", this.cdmMeaning);
            });
        }else if(searchByValue == 'ORDER_SEARCH'){
              $("#single-search-value").val("");
              $("#ban-order-number-div").show();
              $("#last-house-zip-div").hide();
              $("#last-house-zip-serial-div").hide();
              const orderSearchOptions = attOptionsData.ORDER_SEARCH;
              $(orderSearchOptions).each(function(){
                if(this.cdmDescription == 'Y'){
                  $("#single-search-value").prop('required', true);
                }else {
                  $("#single-search-value").prop('required', false);
                }
                  $("#single-search-value").attr("placeholder", this.cdmMeaning);
              });
          }else if(searchByValue == 'HOUSE_SEARCH'){
                $("#first-search-value").val("");
                $("#second-search-value").val("");
                $("#third-search-value").val("");
                $("#last-house-zip-div").show();
                $("#ban-order-number-div").hide();
                $("#last-house-zip-serial-div").hide();
                const houseSearchOptions = attOptionsData.HOUSE_SEARCH;
                $(houseSearchOptions).each(function(){
                  if(this.cdmValue == 'lastName'){
                    if(this.cdmDescription == 'Y'){
                      $("#first-search-value").prop('required', true);
                    }else {
                      $("#first-search-value").prop('required', false);
                    }
                      $("#first-search-value").attr("placeholder", this.cdmMeaning);
                  }else if(this.cdmValue == 'houseNumber'){
                    if(this.cdmDescription == 'Y'){
                      $("#second-search-value").prop('required', true);
                    }else {
                      $("#second-search-value").prop('required', false);
                    }
                      $("#second-search-value").attr("placeholder", this.cdmMeaning);
                  }else{
                    if(this.cdmDescription == 'Y'){
                      $("#third-search-value").prop('required', true);
                    }else {
                      $("#third-search-value").prop('required', false);
                    }
                      $("#third-search-value").attr("placeholder", this.cdmMeaning);
                  }
                });
            }else if(searchByValue == 'HOUSE_AND_SERIAL_SEARCH'){
                  $("#one-search-value").val("");
                  $("#two-search-value").val("");
                  $("#three-search-value").val("");
                  $("#four-search-value").val("");
                  $("#last-house-zip-serial-div").show();
                  $("#last-house-zip-div").hide();
                  $("#ban-order-number-div").hide();
                  const houseSerialSearchOptions = attOptionsData.HOUSE_AND_SERIAL_SEARCH;
                  $(houseSerialSearchOptions).each(function(){
                    if(this.cdmValue == 'lastName'){
                      if(this.cdmDescription == 'Y'){
                        $("#one-search-value").prop('required', true);
                      }else {
                        $("#one-search-value").prop('required', false);
                      }
                        $("#one-search-value").attr("placeholder", this.cdmMeaning);
                    }else if(this.cdmValue == 'houseNumber'){
                      if(this.cdmDescription == 'Y'){
                        $("#two-search-value").prop('required', true);
                      }else {
                        $("#two-search-value").prop('required', false);
                      }
                        $("#two-search-value").attr("placeholder", this.cdmMeaning);
                    }else if(this.cdmValue == 'zipCode'){
                      if(this.cdmDescription == 'Y'){
                        $("#three-search-value").prop('required', true);
                      }else {
                        $("#three-search-value").prop('required', false);
                      }
                        $("#three-search-value").attr("placeholder", this.cdmMeaning);
                    }else{
                      if(this.cdmDescription == 'Y'){
                        $("#four-search-value").prop('required', true);
                      }else {
                        $("#four-search-value").prop('required', false);
                      }
                        $("#four-search-value").attr("placeholder", this.cdmMeaning);
                    }
                  });
              }
  }

  function initComponents(){
    instantiateSelect2($('.select2-select'));
    instantiateSwitchery($('.js-switchery'));
    bindDocSelect2CloseRefocus();
    bindSelect2OnTypeForDesktop();
    setItemsInitialState();
  }

  //bind only the fxo-receiving-submit-screen.jsp elements here.
  function bindElements() {
    $("#cutomer-serach-by").change(chooseInputPlaceholder);
    $(".retrieve-customer-return").click(searchCustomerReturn);
    $(".customer-serach-value").keyup(searchCustomerReturnOnEnter);

    EditChecker.bindNavigation();
    EditChecker.bindChangeListener("#fxo-return-rma-form");
    EditChecker.bindCancelButton("#fxo-rma-return-cancel");
    EditChecker.bindChangeListener("#fxo-search-customer-details-form");

// AT&T: serial number input search
    // on click event for serial plus number text button
    parentForm.on("click",'.prod-ser-num-search', prodSerNumSearch);
    if($("#fxo-receiving-screen").data("fxo-scan-remove-ampersand") == true) {
      parentForm.on("keyup keypress change",'.product-serial-number-input', removeAmpersand);
      parentForm.on("keyup keypress change",'#single-search-value', removeAmpersand);
      parentForm.on("keyup keypress change",'#four-search-value', removeAmpersand);
    }
    // item search by sku from model popup
    parentForm.on("click",'.sku_upc_section_search', skuUpcSectionSearchFun);
    parentForm.on("click",'.sku_upc_btn', showSkuUpcSection);
    parentForm.on("click",'.model_number_btn', showModelNumSection);
    parentForm.on("click", '#submit-fox-returns-btn', validateAndSubmit);
    parentForm.on("change", '.rma-receiving-product-checkbox', selectItemChange);
    parentForm.on("click", '.view-item-image-btn', getItemImages);
    parentForm.on("click", '.model-add-return-item-btn', modelAddReturnItemFun);
    parentForm.on("change", '#customer-search-by', showATTOptionsDiv);
    // manual check in button click event
    parentForm.on("click", '.manual-check-in-btn', manualCheckinClick);
    parentForm.on("click", '.go-to-return-lookup', goToReturnLookup);

    parentForm.on("click", '.update-boxes-btn', showUpdateBoxQuantityModal);
	parentForm.on("click", '.update-poly-bags-btn', showUpdatePolyBagQuantityModal);
	
	parentForm.on("change", '#number-of-poly-bags', showWarningsForPolyBagsQuantityExceeds);
    parentForm.on("click", '.update-boxes-btn-on-modal', addMoreShipmentBoxes);
	parentForm.on("click", '.update-poly-bags-btn-on-modal', addMoreShipmentPolyBags);
    parentForm.on("click", '.remove-box-btn', removeBox);
	parentForm.on("click", '.remove-poly-bag-btn', removePolyBag);

    parentForm.on("click", '.edit-max-box-quantity-on-modal', showUpdateBoxQuantityModal);
	parentForm.on("click", '.edit-max-poly-bag-quantity-on-modal', showUpdatePolyBagQuantityModal);

    parentForm.on("change", '.select-ship-boxes', validateBoxSelection);
	parentForm.on("change", '.select-ship-poly-bags', validatePolyBagSelection);
    parentForm.on("keyup keypress change",'.quantity-in-box-input', removeNonDigit);
	parentForm.on("keyup keypress change",'.quantity-in-poly-bag-input', removeNonDigit);
    parentForm.on("click", '.go-to-serial-number', goToSerialNumber);
	parentForm.on("click", '.cancel-polyBag', cancelPolybagCount);
	parentForm.on("click", '.close-polyBag .top-close-btn', cancelPolybagCount);
	
	parentForm.on("click", '.cancel-box', cancelBoxCount);
	parentForm.on("click", '.close-box .top-close-btn', cancelBoxCount);
  }

  const mainModal = $(render(
    modalHtml,
    {
      title: 'Serial Number Not Found',
      leftAlignTitle: true,
      body: mainModalHtml,
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>'
    }
  ));

  const receiptExistModal = $(render(
    modalHtml,
    {
      title: 'Receipt Already Exist',
      leftAlignTitle: true,
      body: receiptExistForBanNoHtml,
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide go-to-return-lookup">Go to Return Lookup</a> <a href="#" class="base-btn purple-btn modal-auto-hide">Continue</a>'
    }
  ));

  const updateBoxQuantityModal = $(render(
    modalHtml, {
      modalDialogClass: 'q-modal-dialog-500 close-box',
      title: 'How many boxes?',
      leftAlignTitle: true,
      body: updateBoxQuantityModalBody,
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns:'<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide cancel-box">Cancel</a><a href="#" class="base-btn purple-btn update-boxes-btn-on-modal">Update Boxes</a>'
    }
  ));
  
  const updatePolyBagQuantityModal = $(render(
    modalHtml, {
      modalDialogClass: 'q-modal-dialog-500 close-polyBag',
      title: 'How many poly bags?',
      leftAlignTitle: true,
      body: updatePolyBagsQuantityModalBody,
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns:'<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide cancel-polyBag">Cancel</a><a href="#" class="base-btn purple-btn update-poly-bags-btn-on-modal">Update PolyBags</a>'
    }
  ));

  const warningModalBodyFor10Modal = $(render(
    modalHtml, {
      modalDialogClass: 'q-modal-dialog-500',
      title: 'Box Quantity Alert',
      leftAlignTitle: true,
      body: render(warningModalBodyFor10BoxBody,{
        warnDisplay: addBoxWarnDisplay,
        maxDisplay: addBoxMaxDisplay
      }),
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns:'<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn modal-auto-hide">Continue</a>'
    }
  ));

  const warningModalBodyFor30Modal = $(render(
    modalHtml, {
      modalDialogClass: 'q-modal-dialog-500',
      title: 'Maximum Box Quantity',
      leftAlignTitle: true,
      body: render(warningModalBodyFor30BoxBody,{
        maxDisplay: addBoxMaxDisplay
      }),
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns:'<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-max-box-quantity-on-modal">Edit Box Quantity</a>'
    }
  ));

  const invalidEntryModalForSerialNumber = $(render(
    modalHtml, {
      modalDialogClass: '.q-modal-dialog-800',
      title: 'Invalid Entry',
      leftAlignTitle: true,
      body: invalidEntryModalBodyForSerialNumberHtml,
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: '<a href="#" class="base-btn purple-btn modal-auto-hide go-to-serial-number">Okay</a>'
    }
  ));  

  $('#fxo-receiving-screen').append(mainModal);
  $('#fxo-receiving-screen').append(receiptExistModal,updateBoxQuantityModal,updatePolyBagQuantityModal,warningModalBodyFor10Modal,warningModalBodyFor30Modal,invalidEntryModalForSerialNumber);
  const prodSerNumSearchBtn = $('.prod-ser-num-search');
  const fxoReturnRmaForm = $('#fxo-return-rma-form');
  const parentForm = $('#fxo-receiving-screen');
  const skuUpcBtnFromModel = $('.sku_upc_btn');
  const skuUpcBtnTxt = $('.sku_upc_btn_txt');
  const modelNumBtn = $('.model_number_btn');
  const modelNumBtnTxt = $('.model_num_btn_txt');
  const skuUpcSection = $('.sku_upc_section');
  const skuUpcSectionPanel = $('.sku_upc_section_panel');
  const skuUpcSectionSearchInput = $('.sku_upc_section_search_input');
  const modelNumSection = $('.model_number_section');
  const modelNumSectionPanel = $('.model_number_section_panel');
  const modelNumberSectionSearch = $('.model_number_section_search');
  const modelNumberSectionSearchInput = $('.model_number_section_search_input');
  const serialSearchModalForm = $('#serial-search-modal-form');
  const skuAddProductsContainer = $(".sku-add-products-container");
  const modelAddProductsContainer = $(".model-add-products-container");
  const modelAddProductErr= $('.model-add-product-err');
  const skuAddProductErr= $('.sku-add-product-err');
  const manualCheckinSection = $('.manual-check-in-section');
  const fxoManualCheckinCustomMsg = $('.fxo-manual-checkin-custom-msg');
  const fxoNoOfBoxInput = $("#number-of-boxes");
  const fxoNoOfPolyBagInput = $("#number-of-poly-bags");
  const expectedReturnQty = $("#fxo-receiving-screen").data("extected-return-qty");
  const retailerReturnConfig = $("#fxo-receiving-screen").data("retailer-return-config");
  const productSerialNumberInputErrorDiv = $('#product-serial-number-input-error-div');
// AT&T: first call
// serial number serach for AT&T
  function prodSerNumSearch(e) {
    
    e.preventDefault();
    const serialNumberValue = $('.product-serial-number-input').val().trim();
    if(serialNumberValue == '') {
        $('#product-serial-number-input-error-div').show();
    } else {
              if(serialNumberValue.indexOf(',') > -1 || serialNumberValue.indexOf('.') > -1 || serialNumberValue.indexOf(' ') > -1 ||  serialNumberValue.length > 25 ){
                showInvalidSkuModal();
              }else{
                searchItmSku(serialNumberValue, e);
              }
            }
    } 
	
	function cancelPolybagCount(){
		$("#number-of-poly-bags").val($("#number-of-poly-bags-hidden").val());
	}
	
	function cancelBoxCount(){
		$("#number-of-boxes").val($("#number-of-boxes-input-hidden").val());
	}
	
function searchItmSku(serialVal,e) {
  e.preventDefault();
  let itmfound = false;
          $.ajax({
             url: mainEl.data('serial-search-sku-url'),
             type: 'POST',
             dataType: 'json',
             data: {'sku':serialVal},
             success: function(resp){
               let itemData = resp.data;
               if (itemData && itemData != null && itemData != 'null') {
                    showInvalidSkuModal();
               }else{
                  sucessfulSearchItmSkuValidSerial(e);
               }
             },
             error: function(error){
               errorSearchItmSku();
             }
          });
      return itmfound;
  }

  function showInvalidSkuModal(){
     submitModalFlow.hideAllModals();
     invalidEntryModalForSerialNumber.modal('show');
  }
// AT&T: search further after a valid serial number no commas etc
  function sucessfulSearchItmSkuValidSerial(e){
    productSerialNumberInputErrorDiv.hide();
    submitModalFlow.showLoadingModal();
     if($('.product-serial-number-input').val().toUpperCase() === "UNSCANNABLE") {
              $('.product-serial-number-input').val("UNSCANNABLE");
              submitModalFlow.hideAllModals();
              mainModal.modal("show");
              showSkuUpcSection();
          } else {
              serialNumberReceiptValidation(e);
          }
  }

  function errorSearchItmSku(){
    submitModalFlow.showFailureModal();
  }

  var serialNumberValidated = function() {
    var serialNumberInput = $('.product-serial-number-input').val();
    var serialNumberValidationFlag = false;
    $.each($(".fxo-loopable-item-container"), function(index,itemDiv) {
        if($(itemDiv).find('.serial-receipts'+index).val() == serialNumberInput) {
              submitModalFlow.hideAllModals();
              $('.serial-number-validated-msg'+index).show();
              $(itemDiv).find('.serialNumberInput'+index).val(serialNumberInput);
              $(itemDiv).find('.serialNumberInput'+index).attr('disabled','disabled');
              $(itemDiv).find('.rma-receiving-product-checkbox').prop('checked', true);
              // remove disable of item checkbox on serial number match
              $(itemDiv).find('.rma-receiving-product-checkbox').removeAttr('disabled');
              $(itemDiv).find(".rma-receiving-product-checkbox").trigger("change");
              serialNumberValidationFlag = true;
        }
    });
    return serialNumberValidationFlag;
  }

  // From modal, SKU/UPC search button event
  function showSkuUpcSection(){
    skuUpcSection.show();
    skuUpcBtnFromModel.addClass('modal-link-active');
    modelNumBtnTxt.addClass('link-color');
    modelNumBtn.removeClass('modal-link-active');
    skuUpcBtnTxt.removeClass('link-color');
    skuUpcSectionPanel.hide();
    modelNumSection.hide();
    skuAddProductErr.hide();
  }

  function showModelNumSection(){
    modelNumSection.show();
    modelNumBtn.addClass('modal-link-active');
    skuUpcBtnTxt.addClass('link-color');
    skuUpcBtnFromModel.removeClass('modal-link-active');
    modelNumBtnTxt.removeClass('link-color');
    modelNumSectionPanel.hide();
    skuUpcSection.hide();
    modelAddProductErr.hide();
  }

  function handleNoSelectionErrorDisplay(itemSelected){
    if(itemSelected) {
        $(".fxo-return-empty-selection-error-message").hide();
    } else {
        $(".fxo-return-empty-selection-error-message").show();
    }
  }

  function handleNotAllBoxesUsedErrorDisplay(allBoxesUsed){
    if(allBoxesUsed) {
        $(".fxo-return-not-all-boxes-used-error-message").hide();
    } else {
        $(".fxo-return-not-all-boxes-used-error-message").show();
    }
  }
  
  function handleNotAllPolyBagsUsedErrorDisplay(allPolyBagsUsed){
    if(allPolyBagsUsed) {
        $(".fxo-return-not-all-poly-bags-used-error-message").hide();
    } else {
        $(".fxo-return-not-all-poly-bags-used-error-message").show();
    }
  }

  function handleQtExceedErrorDisplay(allowedQty){
    if(allowedQty) {
        $(".fxo-return-qty-exceed-error-message").hide();
    } else {
        $(".fxo-return-qty-exceed-error-message").show();
    }
  }

function allocateOneBoxPerProduct() {
    var noOfBoxes = $(".rma-receiving-product-checkbox:checked").length;
    if(noOfBoxes > 0) {
      var boxNo = 1;
      $.each($(".fxo-loopable-item-container"), function(i, v){
          var itemCheckbox = $(v).find(".rma-receiving-product-checkbox");
          if(itemCheckbox.is(":checked")){
            $(v).find(".boxNumber").val(boxNo);
            $(v).find(".box-number-txt").text((boxNo) + ' of ' + noOfBoxes);
            boxNo++;
          } else {
            $(v).find(".boxNumber").val('');
            $(v).find(".box-number-txt").text('');
          }
      });
    } else {
      $(".box-number-txt").text('');
    }
  }
  function allocateOnePolyBagPerProduct() {
    var noOfPolyBags = $(".rma-receiving-product-checkbox:checked").length;
    if(noOfPolyBags > 0) {
      var polyBagNo = 1;
      $.each($(".fxo-loopable-item-container"), function(i, v){
          var itemCheckbox = $(v).find(".rma-receiving-product-checkbox");
          if(itemCheckbox.is(":checked")){
            $(v).find(".polyBagNumber").val(polyBagNo);
            $(v).find(".poly-bag-number-txt").text((polyBagNo) + ' of ' + noOfPolyBags);
            polyBagNo++;
          } else {
            $(v).find(".polyBagNumber").val('');
            $(v).find(".poly-bag-number-txt").text('');
          }
      });
    } else {
      $(".poly-bag-number-txt").text('');
    }
  }

  
  
  function showUpdateBoxQuantityModal(){
    hideAllBoxModals();

    const modalErrEl = updateBoxQuantityModal.find(".add-box-modal-error");
    modalErrEl.html("");
    modalErrEl.hide();
	$("#number-of-boxes-input-hidden").val(fxoNoOfBoxInput.val());
    updateBoxQuantityModal.modal('show');
  }
  
  function showUpdatePolyBagQuantityModal(){
    hideAllPolyBagModals();
    const modalwarnEl = updatePolyBagQuantityModal.find(".add-poly-bag-modal-error");
    modalwarnEl.html("");
    modalwarnEl.hide();
	$("#number-of-poly-bags-hidden").val(fxoNoOfPolyBagInput.val());
    updatePolyBagQuantityModal.modal('show');
  }
  
 function showWarningsForPolyBagsQuantityExceeds(){
        var noOfPolyBags = fxoNoOfPolyBagInput.val();
        if(retailerReturnConfig != 'defaultItemReturn'){
            const modalwarnEl = updatePolyBagQuantityModal.find(".add-poly-bag-modal-error");
            modalwarnEl.hide();
            modalwarnEl.html("You have requested more poly bags than product quantity.  Please confirm poly bag count.  Use as few poly bags as possible.");
            if(noOfPolyBags > totalItemsOnPage){
                modalwarnEl.show();
            }else{
            modalwarnEl.hide();
            }
        }else{
        const modalwarnEl = updatePolyBagQuantityModal.find(".add-poly-bag-modal-error");
        modalwarnEl.hide();
        modalwarnEl.html("Use as few poly bags as possible.  Select Update Quantity if this amount is correct, or reduce quantity as needed then select Update Quantity ");
        if(noOfPolyBags >addPolyBagWarnLimit){
                modalwarnEl.show();
            }
            else
            modalwarnEl.hide();
    }
    }


  function updateShipmentBoxesForDefaultItems() {
    var requstedNoOfBoxes = fxoNoOfBoxInput.val();
    var curNoOfBoxes = $(".fxo-loopable-item-container").length;
    if(requstedNoOfBoxes > curNoOfBoxes) {
      for(var i = curNoOfBoxes + 1; i <= requstedNoOfBoxes; i++) {
        var newBoxDiv = $("#fxo-loopable-item-container").clone();
        newBoxDiv.find(".quantity-in-box-input").val('');
        newBoxDiv.find(".boxNumber").val('');
        newBoxDiv.find(".box-number-txt").text('');
        $("#returnable-items-container").append(newBoxDiv);
        newBoxDiv.find(".remove-box-btn-div").show();
      }
    } else if(requstedNoOfBoxes < curNoOfBoxes && curNoOfBoxes > 1) {
      var curBoxes = $(".fxo-loopable-item-container");
      var boxesTobeRemoved = curNoOfBoxes - requstedNoOfBoxes;
      for(var i = curNoOfBoxes - 1; i >= requstedNoOfBoxes; i--) {
        curBoxes[i].remove();
      }
    }
    renameClonedReceiptInputNamesForDataBinding();
    allocateOneBoxPerProduct();
  }
  
  function updateShipmentPolyBagsForDefaultItems() {
    var requstedNoOfPolyBags = fxoNoOfPolyBagInput.val();
    var curNoOfPolyBags = $(".fxo-loopable-item-container").length;
    if(requstedNoOfPolyBags > curNoOfPolyBags) {
      for(var i = curNoOfPolyBags + 1; i <= requstedNoOfPolyBags; i++) {
        var newPolyBagDiv = $("#fxo-loopable-item-container").clone();
        newPolyBagDiv.find(".quantity-in-poly-bag-input").val('');
        newPolyBagDiv.find(".polyBagNumber").val('');
        newPolyBagDiv.find(".poly-bag-number-txt").text('');
        $("#returnable-items-container").append(newPolyBagDiv);
        newPolyBagDiv.find(".remove-poly-bag-btn-div").show();
      }
    } else if(requstedNoOfPolyBags < curNoOfPolyBags && curNoOfPolyBags > 1) {
      var curPolyBags = $(".fxo-loopable-item-container");
      var polyBagsTobeRemoved = curNoOfPolyBags - requstedNoOfPolyBags;
      for(var i = curNoOfPolyBags - 1; i >= requstedNoOfPolyBags; i--) {
        curPolyBags[i].remove();
      }
    }
    renameClonedReceiptInputNamesForDataBinding();
    allocateOnePolyBagPerProduct();
  }

function updateShipmentPolyBagsForProductCatalogue() {
   var requstedNoOfPolyBags = fxoNoOfPolyBagInput.val();
    var curNoOfPolyBags = $(".fxo-loopable-item-container").length;
    if(requstedNoOfPolyBags == curNoOfPolyBags) {
		$(".additional-item-div").show();
			$(".additional-item-div .remove-poly-bag-btn-div").show();
	} else if(requstedNoOfPolyBags > curNoOfPolyBags){
		$(".additional-item-div").show();
		$(".additional-item-div .remove-poly-bag-btn-div").show();
		for(var i = curNoOfPolyBags+1; i <= requstedNoOfPolyBags; i++) {
		
		var newPolyBagDiv = $(".fxo-loopable-item-container:last").clone();
		newPolyBagDiv.find(".select2").remove();
        newPolyBagDiv.find("select").select2();
		$(".additional-item-div").append(newPolyBagDiv);
	 	newPolyBagDiv.find(".remove-poly-bag-btn-div").show();
		
   lineItemIndexing();
      }
    }else if(requstedNoOfPolyBags < curNoOfPolyBags && curNoOfPolyBags > 1) {
      var curPolyBags = $(".fxo-loopable-item-container"); 
     var polyBagsTobeRemoved = curNoOfPolyBags - requstedNoOfPolyBags;
    	 for(var i = curNoOfPolyBags - 1; i >= requstedNoOfPolyBags; i--) { 
			if(i!=totalItemsOnPage && !i< totalItemsOnPage){
       			curPolyBags[i].remove();   
			}  
			if(i==totalItemsOnPage){
				document.getElementById(curPolyBags[i].parentElement.id).style.display="none";
				break;
				
		}  
			
		}      
	    
 }
    renameClonedReceiptInputNamesForDataBinding();
    allocateOnePolyBagPerProduct();
  }
  
  function removeBox() {
    $(this).closest(".fxo-loopable-item-container").remove();
    renameClonedReceiptInputNamesForDataBinding();
    allocateOneBoxPerProduct();
    fxoNoOfBoxInput.val(fxoNoOfBoxInput.val() - 1);
    var curNoOfBoxes = $(".fxo-loopable-item-container").length;
    updateBoxPackingSkuDropdowns(curNoOfBoxes);
  }
  
  function removePolyBag() {
 $(".fxo-return-not-all-poly-bags-used-error-message").hide();
 var additionalItems = $(".additional-item-div .fxo-loopable-item-container").length; 
 if(additionalItems==1){
 document.getElementById("additional-item-div-id").style.display="none";
 }
 else{
	 $(this).closest(".fxo-loopable-item-container").remove();
 }
    renameClonedReceiptInputNamesForDataBinding();
    allocateOnePolyBagPerProduct();
    fxoNoOfPolyBagInput.val(fxoNoOfPolyBagInput.val() - 1);
    var curNoOfPolyBags = $(".fxo-loopable-item-container").length;
	
	//if(retailerReturnConfig != 'defaultItemReturn'){  // removed if condition to apply indexing for default flwo as well
		lineItemIndexing();
		const noOfPolyBags = fxoNoOfPolyBagInput.val();
         $(".select-ship-poly-bags").empty().append('<option value="">Select PolyBag</option>');
            for (var i = 1; i <= noOfPolyBags; i++) {
              $(".select-ship-poly-bags").append('<option value="' + i + '">' + i + ' of ' + noOfPolyBags + '</option>');
            }
	//}
  }
  
  function lineItemIndexing(){
	 //this will add indexes Explicitly for all line items including additional line item(checkbox, dropdown list & poly bag qty input in each line item and 14 hidden elements)
		var hiddenRecItemSkuName = 0;
		$(".hiddenRecItemSku").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecItemSkuName++ +"].recItmSku");
		});
		var hiddenRecItemSkuId=0;
		$(".hiddenRecItemSku").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecItemSkuId++ +"].recItmSku");
		});

		var hiddenRecItmUpcName = 0;
		$(".hiddenRecItmUpc").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecItmUpcName++ +"].recItmUpc");
		});
		var hiddenRecItmUpcId=0;
		$(".hiddenRecItmUpc").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecItmUpcId++ +"].recItmUpc");
		});		

		var hiddenRecProductDescriptionName = 0;
		$(".hiddenRecProductDescription").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecProductDescriptionName++ +"].recProductDescription");
		});
		var hiddenRecProductDescriptionId=0;
		$(".hiddenRecProductDescription").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecProductDescriptionId++ +"].recProductDescription");
		});		

		var hiddenRecCostName = 0;
		$(".hiddenRecCost").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecCostName++ +"].recCost");
		});
		var hiddenRecCostId=0;
		$(".hiddenRecCost").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecCostId++ +"].recCost");
		});	


		var hiddenRecRetailCostName = 0;
		$(".hiddenRecRetailCost").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecRetailCostName++ +"].recRetailCost");
		});
		var hiddenRecRetailCostId=0;
		$(".hiddenRecRetailCost").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecRetailCostId++ +"].recRetailCost");
		});

		var hiddenRecWeightName = 0;
		$(".hiddenRecWeight").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecWeightName++ +"].recWeight");
		});
		var hiddenRecWeightId=0;
		$(".hiddenRecWeight").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecWeightId++ +"].recWeight");
		});		

		var hiddenRecOrderNumberName = 0;
		$(".hiddenRecOrderNumber").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecOrderNumberName++ +"].recOrderNumber");
		});
		var hiddenRecOrderNumberId=0;
		$(".hiddenRecOrderNumber").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecOrderNumberId++ +"].recOrderNumber");
		});	

		var hiddenRecRmaOrderNumberName = 0;
		$(".hiddenRecRmaOrderNumber").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecRmaOrderNumberName++ +"].recRmaOrderNumber");
		});
		var hiddenRecRmaOrderNumberId=0;
		$(".hiddenRecRmaOrderNumber").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecRmaOrderNumberId++ +"].recRmaOrderNumber");
		});	

		var hiddenRecRmaOrderDateName = 0;
		$(".hiddenRecRmaOrderDate").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecRmaOrderDateName++ +"].recRmaOrderDate");
		});
		var hiddenRecRmaOrderDateId=0;
		$(".hiddenRecRmaOrderDate").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecRmaOrderDateId++ +"].recRmaOrderDate");
		});	

		var hiddenRecQtyName = 0;
		$(".hiddenRecQty").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecQtyName++ +"].recQty");
		});
		var hiddenRecQtyId=0;
		$(".hiddenRecQty").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecQtyId++ +"].recQty");
		});	

		var hiddenRecDestinationName = 0;
		$(".hiddenRecDestination").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecDestinationName++ +"].recDestination");
		});
		var hiddenRecDestinationId=0;
		$(".hiddenRecDestination").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecDestinationId++ +"].recDestination");
		});	


		var hiddenItmShipToAddressIdName = 0;
		$(".hiddenItmShipToAddressId").each(function(){
		$(this).attr('name', "receipts["+ hiddenItmShipToAddressIdName++ +"].itmShipToAddressId");
		});
		var hiddenItmShipToAddressIdId=0;
		$(".hiddenItmShipToAddressId").each(function(){
		$(this).attr('id', "receipts["+ hiddenItmShipToAddressIdId++ +"].itmShipToAddressId");
		});	

		var hiddenRecWsTypeName = 0;
		$(".hiddenRecWsType").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecWsTypeName++ +"].recWsType");
		});
		var hiddenRecWsTypeId=0;
		$(".hiddenRecWsType").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecWsTypeId++ +"].recWsType");
		});	

		var hiddenRecRmdIdName = 0;
		$(".hiddenRecRmdId").each(function(){
		$(this).attr('name', "receipts["+ hiddenRecRmdIdName++ +"].recRmdId");
		});
		var hiddenRecRmdIdId=0;
		$(".hiddenRecRmdId").each(function(){
		$(this).attr('id', "receipts["+ hiddenRecRmdIdId++ +"].recRmdId");
		});	

	//
		var checkBoxName = 0;
		$(".rma-receiving-product-checkbox").each(function(){
		$(this).attr('name', "receipts["+ checkBoxName++ +"].returnRmaItem");
		});
		var checkBoxId=0;
		$(".rma-receiving-product-checkbox").each(function(){
		$(this).attr('id', "receipts["+ checkBoxId++ +"].returnRmaItem");
		});
		// below for poly bag count 1 of 1, 1 of 2 so on during default flow 
		var polyBagCountName = 0;
		$(".polyBagNumber").each(function(){
		$(this).attr('name', "receipts["+ polyBagCountName++ +"].shipmentBoxNo");
		});
		var polyBagCountId=0;
		$(".polyBagNumber").each(function(){
		$(this).attr('id', "receipts["+ polyBagCountId++ +"].shipmentBoxNo");
		}); 
		//below indesing for dropdown list in product catalogue flow
		var selectPolyBagDropdownName = 0;
		$(".select-ship-poly-bags").each(function(){
		$(this).attr('name', "receipts["+ selectPolyBagDropdownName++ +"].shipmentBoxNo");
		});
		var selectPolyBagDropdownId=0;
		$(".select-ship-poly-bags").each(function(){
		$(this).attr('id', "receipts["+ selectPolyBagDropdownId++ +"].shipmentBoxNo");
		}); 
		
		var polyBagQtyInputName = 0;
		$(".quantity-in-poly-bag-input").each(function(){
		$(this).attr('name', "receipts["+ polyBagQtyInputName++ +"].recQty");
		});
		var polyBagQtyInputId=0;
		$(".quantity-in-poly-bag-input").each(function(){
		$(this).attr('id', "receipts["+ polyBagQtyInputId++ +"].recQty");
		}); 
  }

  function validateBoxSelection(e){
    const self = $(this)
    const parent = self.closest('.fxo-loopable-item-container')
    if(self.val() != ""){
      parent.find('.add-box-valid').show();
      parent.find('.add-box-error').hide();
    }else{
      parent.find('.add-box-error').show();
      parent.find('.add-box-valid').hide();
    }
  }
  
  function validatePolyBagSelection(e){
    const self = $(this)
    const parent = self.closest('.fxo-loopable-item-container')
    if(self.val() != ""){
      parent.find('.add-poly-bag-valid').show();
      parent.find('.add-poly-bag-error').hide();
    }else{
      parent.find('.add-poly-bag-error').show();
      parent.find('.add-poly-bag-valid').hide();
    }
	$(".fxo-return-not-all-poly-bags-used-error-message").hide();
  }

  function hideAddBoxValidationPills(el){
    el.find(".add-box-valid").hide();
    el.find(".add-box-error").hide();
  }
  
  function hideAddPolyBagValidationPills(el){
    el.find(".add-poly-bag-valid").hide();
    el.find(".add-poly-bag-error").hide();
  }

  function initAddBoxValidationPills(el){
    el.find(".add-box-valid").hide();
    el.find(".add-box-error").show();
  }
  
  function initAddPolyBagValidationPills(el){
    el.find(".add-poly-bag-valid").hide();
    el.find(".add-poly-bag-error").show();
  }

  function addMoreShipmentBoxes(e) {
    e.preventDefault();
    //hideAddBoxValidationPills();
    const noOfBoxes = fxoNoOfBoxInput.val();
	
    if(retailerReturnConfig != 'defaultItemReturn' && noOfBoxes > totalItemsOnPage){
      const modalErrEl = updateBoxQuantityModal.find(".add-box-modal-error");
      modalErrEl.html("The number of boxes cannot exceed the total number of items.");
      modalErrEl.show();
	  } else {
	  $("#number-of-boxes-input-hidden").val(fxoNoOfBoxInput.val());
      hideAllBoxModals();
      if(noOfBoxes > addBoxMaxLimit){
        showMaxBoxError();	
      } else {
        //hideAllBoxModals();
        if(noOfBoxes >= addBoxWarnLimit){
          showAddBoxWarning();
		 
        }
        if(retailerReturnConfig == 'defaultItemReturn') {
          updateShipmentBoxesForDefaultItems();
          updateBoxPackingSkuDropdowns(noOfBoxes);
        } else {
          if(noOfBoxes <= 1) {
            // set all items box no to 1
            $(".shipment-box-footer").hide();
            updateBoxPackingSkuDropdowns(noOfBoxes);
          } else {
            mainEl.find('.add-box-error').show();
            $(".select-ship-boxes").empty().append('<option value="">Select Box</option>');
            for (var i = 1; i <= noOfBoxes; i++) {
              $(".select-ship-boxes").append('<option value="' + i + '">' + i + ' of ' + noOfBoxes + '</option>');
            }
            $(".shipment-box-footer").show();
            updateBoxPackingSkuDropdowns(noOfBoxes);
          }
        }
      }
    }
  }

function addMoreShipmentPolyBags(e) {
    e.preventDefault();
	$(".fxo-return-not-all-poly-bags-used-error-message").hide();
    const noOfPolyBags = fxoNoOfPolyBagInput.val();
	$("#number-of-poly-bags-hidden").val(fxoNoOfPolyBagInput.val());
    if(retailerReturnConfig != 'defaultItemReturn'){ //  && noOfPolyBags >= totalItemsOnPage - this fixed issue when we reduce qty less than physical item
	  hideAllPolyBagModals();
	  updateShipmentPolyBagsForProductCatalogue();
            $(".select-ship-poly-bags").empty().append('<option value="">Select PolyBag</option>');
            for (var i = 1; i <= noOfPolyBags; i++) {
              $(".select-ship-poly-bags").append('<option value="' + i + '">' + i + ' of ' + noOfPolyBags + '</option>');
            }
    } else
		if(retailerReturnConfig == 'defaultItemReturn') {
		  hideAllPolyBagModals();
          updateShipmentPolyBagsForDefaultItems();
            $(".select-ship-poly-bags").empty().append('<option value="">Select PolyBag</option>');
            for (var i = 1; i <= noOfPolyBags; i++) {
              $(".select-ship-poly-bags").append('<option value="' + i + '">' + i + ' of ' + noOfPolyBags + '</option>');
            }           
          }
  }


  function updateBoxPackingSkuDropdowns(noOfBoxes){
    const casSkus = mainEl.data('cas-sku-list'); 
    const allCasSkus = casSkus.allSkus;
    const casSkuOptions = allCasSkus.map((el)=>{
      return render(packingSkuOptionHtml, {
        key: el.efcValue,
        value: el.efcDescription
      })
    }).join('');

    let outputHtml = '';
    for (var i = 1; i <= noOfBoxes; i++) {
      outputHtml += render(packingSkuListHtml, {
        boxId: i,
        totalBoxes: noOfBoxes,
        packingSkuList: casSkuOptions
      });
    }
    mainEl.find('.multi-box-paking-sku-container').html(outputHtml);
    initComponents();
  }
  
  function updatePolyBagPackingSkuDropdowns(noOfPolyBags){
    const casSkus = mainEl.data('cas-sku-list');
    const allCasSkus = casSkus.allSkus;
    const casSkuOptions = allCasSkus.map((el)=>{
      return render(packingSkuOptionHtml, {
        key: el.efcValue,
        value: el.efcDescription
      })
    }).join('');

    let outputHtml = '';
    for (var i = 1; i <= noOfPolyBags; i++) {
      outputHtml += render(packingSkuListHtml, {
        polyBagId: i,
        totalPolyBags: noOfPolyBags,
        packingSkuList: casSkuOptions
      });
    }
    mainEl.find('.multi-poly-bag-paking-sku-container').html(outputHtml);
    initComponents();
  }
  

  function hideAllBoxModals(){
    updateBoxQuantityModal.modal('hide');
    warningModalBodyFor10Modal.modal('hide');
    warningModalBodyFor30Modal.modal('hide');
  }

function hideAllPolyBagModals(){
    updatePolyBagQuantityModal.modal('hide');
    //warningModalBodyFor10Modal.modal('hide');
    //warningModalBodyFor30Modal.modal('hide');
  }

  function showMaxBoxError(){
    warningModalBodyFor30Modal.modal('show');
  }
  
  function showMaxPolyBagError(){
    warningModalBodyFor30Modal.modal('hide');
  }

  function showAddBoxWarning(){
    warningModalBodyFor10Modal.modal('show');
  }
  
  function showAddPolyBagWarning(){
    warningModalBodyFor10Modal.modal('hide');
  }

  function selectItemChange(){
    var itemContainer = $(this).closest(".fxo-loopable-item-container");
    var itemCheckbox = $(this);
    $.each(itemContainer.find(".requiredWhenSelected"), function(i, v){
        if(itemCheckbox.is(":checked")){
            $(v).addClass("required");
            handleNoSelectionErrorDisplay(true);
        } else {
            $(v).removeClass("required");
            $(v).val("").trigger("change");
            $("#fxo-return-rma-form").valid();
            itemContainer.find('.serial-number-validated-static-msg').hide();
        }
    });
	
    // Make checkbox disable if click event is happen
    if($(itemContainer.find(".serial-number-section")).val() != undefined && !itemCheckbox.is(":checked")) {
		
        itemCheckbox.prop('disabled', true);
    }
	if(($("#rmaReceivingType").val() == 'mmc' || $("#rmaReceivingType").val() == 'consolidated_acceptance') && retailerReturnConfig == 'defaultItemReturn') {
        allocateOnePolyBagPerProduct();
    }else if(($("#rmaBoxConfig").val() == 'OPSB' || retailerReturnConfig == 'defaultItemReturn') && !($("#rmaReceivingType").val() == 'mmc' && $("#rmaReceivingType").val() == 'consolidated_acceptance')) {
      allocateOneBoxPerProduct();
    }

    //Handle toggle item disabled/enabled state
    handleToggleItem(itemCheckbox)
  }

  function handleCheckItemSelection(){
    var itemSelected = false;
    const allBoxesUsed = [];

    $.each($(".fxo-loopable-item-container"), function(i, v){
        var itemCheckbox = $(v).find(".rma-receiving-product-checkbox");
        if(itemCheckbox.is(":checked")){
            itemSelected = true;
            if(retailerReturnConfig == 'defaultItemReturn') {
              allBoxesUsed.push($(v).find(".boxNumber").val());
            } else {
              allBoxesUsed.push($(v).find('.select-ship-boxes').val());
            }
        }
    });

    handleNoSelectionErrorDisplay(itemSelected);

    //Piggy pack on validation if they didnt use all the boxes
    itemSelected = handleCheckBoxSelection(allBoxesUsed);

    return itemSelected;
  }
  
  function handleCheckItemSelectionForPolyBag(){
    var itemSelected = false;
    const allPolyBagsUsed = [];
    $.each($(".fxo-loopable-item-container"), function(i, v){
        var itemCheckbox = $(v).find(".rma-receiving-product-checkbox");
        if(itemCheckbox.is(":checked")){
            itemSelected = true;
            if(retailerReturnConfig == 'defaultItemReturn') {
              allPolyBagsUsed.push($(v).find(".polyBagNumber").val());
            } else {
					if($(v).find('.select-ship-poly-bags').val().trim().length>0){
					allPolyBagsUsed.push($(v).find('.select-ship-poly-bags').val());
					}
            }
        }
    });

    handleNoSelectionErrorDisplay(itemSelected);
    itemSelected = handleCheckBoxSelectionForPolyBags(allPolyBagsUsed);

    return itemSelected;
  }

  function handleCheckBoxSelection(allBoxesUsed){
    let valid = true;
    const noOfBoxes = fxoNoOfBoxInput.val();
    const uniqueBoxes = _.uniq(allBoxesUsed);

    if(noOfBoxes != uniqueBoxes.length){
      valid = false;
    }
    // Used same function as FCR and handled error msg in jsp
    handleNotAllPolyBagsUsedErrorDisplay(valid);
    return valid;
  }
  
  function handleCheckBoxSelectionForPolyBags(allPolyBagsUsed){
    let valid = true;
    const noOfPolyBags = fxoNoOfPolyBagInput.val();
    const uniquePolyBags = _.uniq(allPolyBagsUsed);
	var requstedNoOfPolyBags = fxoNoOfPolyBagInput.val();
	 
    if(noOfPolyBags != uniquePolyBags.length){
      valid = false;
    }
    handleNotAllPolyBagsUsedErrorDisplay(valid);
    return valid;
  }

  // This method is required for Jquery validation and Spring data bining
  function renameClonedReceiptInputNamesForDataBinding() {
    $(".fxo-loopable-item-container").each(function(index, boxDiv) {
      $(boxDiv).find('[name^=receipts]').each(function(i, inputEle) {
        var newName = $(this).attr('name').replace('[0]', '[' + index + ']');
        $(this).attr('name', newName);
        $(this).attr('id', newName);
      });
    });
  }

function validateAndSubmit(e){
    e.preventDefault();
	var requstedNoOfPolyBags = fxoNoOfPolyBagInput.val();
    var curNoOfPolyBags = $(".fxo-loopable-item-container").length;
    
	
    var itemSelectValidity;   
    var validity = $("#fxo-return-rma-form").valid();
    if($("#rmaReceivingType").val() == 'mmc' || $("#rmaReceivingType").val() == 'consolidated_acceptance'){
	    itemSelectValidity = handleCheckItemSelectionForPolyBag();
	}
	else{
	    itemSelectValidity = handleCheckItemSelection();
	}
    if(validity && itemSelectValidity){
	if(($("#rmaReceivingType").val() == 'mmc' || $("#rmaReceivingType").val() == 'consolidated_acceptance') && retailerReturnConfig != 'defaultItemReturn'){
	if(requstedNoOfPolyBags<= totalItemsOnPage){
		deleteRow();
	}
	}
      submitFxoReturns();
    }
  }
function deleteRow()
{
	var additionalItemDiv = document.getElementsByClassName("additional-item-div");
	$("#"+additionalItemDiv[0].id).remove();
	//alert("Add Removed" );
   //AJAX call here
  //pass this clickedId to Servlet and delete the row , show response back to user 
} 

  // Search items from sku or upc
  function skuUpcSectionSearchFun(e) {
      e.preventDefault();
      skuAddProductErr.hide();
      if(serialSearchModalForm.valid()){
          $.ajax({
             url: mainEl.data('serial-sku-url'),
             type: 'POST',
             dataType: 'json',
             data: {'sku':skuUpcSectionSearchInput.val()}, // skuUpcSectionSearchInput.val(),
             success: function(resp){
               let itemData = resp.data;
               skuAddProductsContainer.html('');
               if (itemData && itemData != null && itemData != 'null' && itemData.length > 0) {
                   skuUpcSectionPanel.show();
                   $.each(itemData, function (i, v) {
                       let fxoReceivingAddProductEl = $(render(fxoReceivingAddProductTemplate,{dataItem:v}));
                       skuAddProductsContainer.append(fxoReceivingAddProductEl);
                   });
               } else {
                   skuUpcSectionPanel.hide();
                   skuAddProductErr.show();
               }
             },
             error: function(error){
               submitModalFlow.showFailureModal();
             }
          });
      }
  };



  // Search items from model number
  modelNumberSectionSearch.on('click', function(e) {
      e.preventDefault();
      modelAddProductErr.hide();
      if(serialSearchModalForm.valid()){
          $.ajax({
             url: mainEl.data('serial-model-url'),
             type: 'POST',
             data: {'model':modelNumberSectionSearchInput.val()}, // skuUpcSectionSearchInput.val(),
             success: function(resp){
               let itemData = JSON.parse(resp).data;
               modelAddProductsContainer.html('');
               if (itemData && itemData != null && itemData != 'null' && itemData.length > 0) {
                   modelNumSectionPanel.show();
                   $.each(itemData, function (i, v) {
                       let fxoReceivingAddProductEl = $(render(fxoReceivingAddProductTemplate,{dataItem:v}));
                       modelAddProductsContainer.append(fxoReceivingAddProductEl);
                   });
               } else {
                   modelNumSectionPanel.hide();
                   modelAddProductErr.show();
               }
             },
             error: function(error){
               submitModalFlow.showFailureModal();
             }
          });
      }
  });

  function submitFxoReturns() {
    submitModalFlow.showLoadingModal();
    var form = $("#fxo-return-rma-form").serialize();
    var url = $("#fxo-receiving-screen").data("submit-fxo-return-url");
    $.ajax({
      url: url,
      type: 'POST',
      dataType: 'html',
      data: form,
      success: function(resp){
       EditChecker.setPageClean();
       submitModalFlow.showSuccessModal();
  	   setTimeout(function() {
  		   submitModalFlow.hideAllModals();
  		   $("#receipt-modal").html(resp);
             $("#fxo-return-receipt-summary-modal").modal("show");
             $("#fxo-return-receipt-summary-modal").on('shown.bs.modal', function() {
               //FxoRmaRevObj.fxoReceiptHandleEnableBtn(); - TODO
           });
       }, window.constants.SUCCESS_MODAL_TIMEOUT);
     }
   });
 }

 function getItemImages(e) {
    e.preventDefault();
    var url = $(this).data("url");
    submitModalFlow.showLoadingModal();
    $.ajax({
      url: url,
      type: 'POST',
  	  dataType: 'html',
  		success: function(resp){
          submitModalFlow.hideAllModals();
          if(resp) {
              $("#item-image-modal").html(resp);
              $("#view-image-of-product-modal").modal("show");
              autoSelectFirstThumbnail();
    			}
  	  }
    });
  }

  function autoSelectFirstThumbnail(){
  	//var thumbnailLength = fxoRmaRevDomVars.linkThumbnailContainer.find(".rma-rev-image-thumbnail").length;
  	var thumbnailLength = $(".rma-rev-thumbnail-container").find(".rma-rev-image-thumbnail").length;
    if(thumbnailLength > 0){
    	//dynamically added content, so defining it again
    	var firstThumbnail = $("#view-image-of-product-modal .rma-rev-image-thumbnail:first");
      //NOTE: this simulates a user click event, which should run handleThumbnailClickEvent function below
      firstThumbnail.trigger("click");
    }
  }

  function chooseInputPlaceholder(){
      //var selectedText = $("#search-dropdown-options option:selected").text().trim();
      var selectedText =  $("#cutomer-serach-by").val();
      var serachBy = $("#customer-serach-value");
      if(selectedText === "Work Order Number"){
          serachBy.prop("placeholder", "Enter or Scan Work Order Number");
      } else if(selectedText === "Serial Number") {
          serachBy.prop("placeholder", "Enter Serial Number");
      } else if(selectedText === "Order Number") {
          serachBy.prop("placeholder", "Enter Order Number");
      } else if(selectedText === "RMA Number") {
          serachBy.prop("placeholder", "Enter or Scan RMA Number");
      } else if(selectedText === "Customer Account #") {
          serachBy.prop("placeholder", "Enter Customer Account #");
      } else if(selectedText === "Customer Email"){
      	 serachBy.prop("placeholder", "Enter Customer Email");
      } else if(selectedText === "First Name"){
      	 serachBy.prop("placeholder", "Enter Customer First Name");
      } else if(selectedText === "Last Name"){
      	 serachBy.prop("placeholder", "Enter Customer Last Name");
      } else if(selectedText === "House Number"){
      	 serachBy.prop("placeholder", "Enter Customer House number");
      } else if(selectedText === "Zip Code"){
      	 serachBy.prop("placeholder", "Enter Customer Zip Code");
      }
  }

  function searchCustomerReturnOnEnter(e) {
    var code = (e.keyCode ? e.keyCode : e.which);
    if (code==13) {
        searchCustomerReturn(e);
    }
  }

  function searchCustomerReturn(e) {
    if( $("#fxo-search-customer-details-form").valid()){
        e.preventDefault();
        submitModalFlow.showLoadingModal();
        var url = $(".retrieve-customer-return").data("url");
        var searchBy = $(".cutomer-serach-by").val();
        var searchValue = '';
        if(searchBy == 'HOUSE_SEARCH'){
          searchValue = $("#first-search-value").val() + ',' +  $("#second-search-value").val() + ',' + $("#third-search-value").val();
        }else if(searchBy == 'HOUSE_AND_SERIAL_SEARCH'){
          searchValue = $("#one-search-value").val() + ',' +  $("#two-search-value").val() + ',' + $("#three-search-value").val() + ',' +  $("#four-search-value").val();
        }else{
          searchValue = $(".customer-serach-value").val();
        }
        $.ajax({
          url: url,
          type: 'POST',
          dataType: 'html',
          data: {retailerId: $("#rtlId").val(), searchBy: searchBy, searchValue: searchValue},
          success: function(resp){
            submitModalFlow.hideAllModals();
            if(manualCheckinSection.hide()) {
                manualCheckinSection.show();
            }
            $("#fxo-receiving-submit-return-items-section").html(resp);
            if($('.fxo-loopable-item-container').length < 1) {
                $('.manual-check-in-div').show();
                // check if iib lookup service response has error code
                let errorMsgFromIIBLookupService = $('.fxo-receiving-screen').data('error-msg-from-iib-lookup');
                if(errorMsgFromIIBLookupService != '') {
                    fxoManualCheckinCustomMsg.html('ATTENTION: '+errorMsgFromIIBLookupService);
                } else {
                    fxoManualCheckinCustomMsg.html("Select from the drop down above to retrieve the customer's return information. If the customer cannot be found, begin the return manually by selecting Manual Check In below.");
                }

            }else {
                manualCheckinSection.hide();
                fxoManualCheckinCustomMsg.html("Select from the drop down above to retrieve the customer's return information.");
            }
            initComponents();
            EditChecker.bindChangeListener("#fxo-return-rma-form");
            $('.product-serial-number-input').focus();
          }
        });
    }
  }

  // Call ajax for render item in receiving screen - manualItemCheckin
  function modelAddReturnItemFun(e) {
    e.preventDefault();
    mainModal.modal("hide");
    // clear sku and model number field form Model
    $('.sku_upc_section_search_input').val('');
    $('.model_number_section_search_input').val('');

    submitModalFlow.showLoadingModal();
    var recordNo = $(".fxo-loopable-item-container").length;
    var itemObj = $(this).closest(".model-add-return-item-btn").data('item');

    var url = $("#fxo-receiving-screen").data("manual-checkin-url") + "&index="+recordNo+"&itemSku="+itemObj.itmSku;
    var form = $("#fxo-return-rma-form").serialize();
    $.ajax({
      url: url,
      type: 'POST',
      dataType: 'html',
      data: form,
      success: function(resp){
        submitModalFlow.hideAllModals();
        manualCheckinSection.hide();
        if($('.return-items-page').hide()) {
            $('.return-items-page').show();
        }
        $('#returnable-items-container').append($(resp).find('#fxo-loopable-item-container'));

        initComponents();
  	    //Call init methos for the new html;
        let productSerialNumberInput = $('.product-serial-number-input');
        let newItemCont = $($(".fxo-loopable-item-container")[recordNo]);
        newItemCont.find(".rma-receiving-product-checkbox").change(selectItemChange);
        newItemCont.find('.rma-receiving-product-checkbox').prop('checked', true);
        // remove disable of item checkbox on serial number match
        newItemCont.find('.rma-receiving-product-checkbox').removeAttr('disabled');
        newItemCont.find(".rma-receiving-product-checkbox").trigger("change");
        // getting the serial no which user has entered and paste it on new added item
        newItemCont.find('.serial-receipts'+recordNo).val(productSerialNumberInput.val());
        newItemCont.find('.serialNumberInput'+recordNo).val(productSerialNumberInput.val());
        newItemCont.find('.serialNumberInput'+recordNo).attr('disabled','disabled');
        newItemCont.find('.serial-number-added-static-msg').hide();
        // Clear the serial number capturing text box
        productSerialNumberInput.val('');
        productSerialNumberInput.focus();
        $('.serial-number-added-msg'+recordNo).show();
      }
    });
  }

  // manual check in button click event
  function manualCheckinClick(e) {
      e.preventDefault();
      let serialNoValidation = $('.fxo-receiving-screen').data('serial-no-validation');
      if(serialNoValidation != true) {
          mainModal.modal("show");
          showSkuUpcSection();
      } else {
          $('.return-items-page').show();
      }
  }

  // Call ajax for render item in receiving screen from AT&T call - manualItemCheckin
  function manualCheckinSerialNoSearch(e) {
    // submitModalFlow.showLoadingModal();
    var recordNo = $(".fxo-loopable-item-container").length;
    var productSerialNumberInput = $(".product-serial-number-input");
    var form = $("#fxo-return-rma-form").serialize();
    var url = $("#fxo-receiving-screen").data("serial-number-lookup-checkin-url") + "&index="+recordNo+"&serialNumber="+productSerialNumberInput.val();
    $.ajax({
      url: url,
      type: 'POST',
      dataType: 'html',
      data: form,
      success: function(resp){
        submitModalFlow.hideAllModals();
        if($($(resp).find('.fxoReceiptExist')).val() === true) {
            receiptExistModal.modal("show");
        }
        else if($(resp).find('.fxo-loopable-item-sku').text().trim() == '') {
            mainModal.modal("show");
            showSkuUpcSection();
        } else {
            $('#returnable-items-container').append($(resp).find('#fxo-loopable-item-container'));
            initComponents();
      	    //Call init methos for the new html;
            let newItemCont = $($(".fxo-loopable-item-container")[recordNo]);
            newItemCont.find(".rma-receiving-product-checkbox").change(selectItemChange);
            newItemCont.find('.rma-receiving-product-checkbox').prop('checked', true);
            // remove disable of item checkbox on serial number match
            newItemCont.find('.rma-receiving-product-checkbox').removeAttr('disabled');
            newItemCont.find(".rma-receiving-product-checkbox").trigger("change");
            // getting the serial no which user has entered and paste it on new added item
            newItemCont.find('.serial-receipts'+recordNo).val(productSerialNumberInput.val());
            newItemCont.find('.serialNumberInput'+recordNo).val(productSerialNumberInput.val());
            newItemCont.find('.serialNumberInput'+recordNo).attr('disabled','disabled');
            newItemCont.find('.serial-number-added-static-msg').hide();
            // Clear the serial number capturing text box
            productSerialNumberInput.val('');
            productSerialNumberInput.focus();
            $('.serial-number-validated-msg'+recordNo).show();
        }
      }
    });
  }
// AT&T: for any input other than UNSCANNABLE
  // serial number receipt validation
  function serialNumberReceiptValidation(e) {
    let productSerialNumberInput = $(".product-serial-number-input");
    let form = $("#fxo-return-rma-form").serialize();
    let url = $("#fxo-receiving-screen").data("serial-number-validation-url") + "&serialNumber="+productSerialNumberInput.val();
    $.ajax({
      url: url,
      type: 'POST',
      dataType: 'html',
      data: form,
      success: function(resp){
        if(JSON.parse(resp).data == 'true') {
            submitModalFlow.hideAllModals();
            receiptExistModal.modal("show");
            productSerialNumberInput.val('');
            productSerialNumberInput.focus();
        } else if(!serialNumberValidated()) {
            manualCheckinSerialNoSearch(e);
        } else {
            submitModalFlow.hideAllModals();
            productSerialNumberInput.val('');
            productSerialNumberInput.focus();
        }
      }
    });
  }

  function goToSerialNumber() {
    $('.product-serial-number-input').val("");
    $('.product-serial-number-input').focus();
    invalidEntryModalForSerialNumber.hide();
  }


  function goToReturnLookup() {
    window.location.href = $("#fxo-return-rma-form").data("return-lookup-page-url");
  }

  function setItemsInitialState(){
    const itemContainer = mainEl.find(".fxo-loopable-item-container").each((index, item)=>{
      const itemCheckbox = $(item).find('.rma-receiving-product-checkbox');
      handleToggleItem(itemCheckbox);
    });
  }

  function handleToggleItem(el){
    const closestTargetEl = el.data('target-closest');
    const parentEl = el.closest(closestTargetEl);
    if(el.prop('checked')){
      handleToggleItemEnabledState(parentEl);
      initAddBoxValidationPills(parentEl);
    } else {
      handleToggleItemDisabledState(parentEl);
      hideAddBoxValidationPills(parentEl);
    }
  }

  function handleToggleItemEnabledState(el){
    el.find('.q-pct-body').removeClass('q-pct-body-disable');
    el.find('.q-pct-body :input').removeAttr('disabled');
    el.find('.q-pct-footer :input').removeAttr('disabled');
    el.find('.select2-container').css('pointer-events','');
  }

  function handleToggleItemDisabledState(el){
    el.find('.q-pct-body').addClass('q-pct-body-disable');
    el.find('.q-pct-body :input').attr('disabled','true');
    el.find('.q-pct-footer :input').attr('disabled','true');
    el.find('.select2-container').css('pointer-events','none');
  }


}



// WEBPACK FOOTER //
// ./src/pages/fxoReceivingScreen/fxoReceivingScreenLogic.js